interface ITomraCanTypes {
  [key: number]: {
    label: string;
    icon: any;
  };
}

export const tomraCanTypes: ITomraCanTypes = {
  10: {
    label: "Can",
    icon: require("../assets/pictures/tomra/can.png"),
  },
  11: {
    label: "Can",
    icon: require("../assets/pictures/tomra/can.png"),
  },
  16: {
    label: "Steel Can",
    icon: require("../assets/pictures/tomra/can.png"),
  },
  17: {
    label: "Steel Can",
    icon: require("../assets/pictures/tomra/can.png"),
  },
  18: {
    label: "Can (NS)",
    icon: require("../assets/pictures/tomra/can.png"),
  },
  19: {
    label: "Can (NS)",
    icon: require("../assets/pictures/tomra/can.png"),
  },
  20: {
    label: "PET-25ct",
    icon: require("../assets/pictures/tomra/bottle.png"),
  },
  21: {
    label: "PET-15ct",
    icon: require("../assets/pictures/tomra/bottle.png"),
  },
  22: {
    label: "Colored PET 25ct",
    icon: require("../assets/pictures/tomra/bottle.png"),
  },
  23: {
    label: "Colored PET 15ct",
    icon: require("../assets/pictures/tomra/bottle.png"),
  },
};
